import React from 'react'
import { createPortal } from 'react-dom'
import type { OverlayProps } from './Overlay.types'
import './Overlay.css'

const Overlay: React.FC<OverlayProps> = ({
  open = true,
  onClick,
  inline = false,
  portal = !inline,
  darkMode = false,
  zIndex,
  className = '',
  style,
  children,
  'aria-label': ariaLabel = 'Overlay backdrop',
}) => {
  if (!open) {
    return null
  }

  const classNames = [
    'ds-overlay',
    inline ? 'ds-overlay--inline' : '',
    darkMode ? 'ds-overlay--dark' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const overlayStyle: React.CSSProperties = {
    ...style,
    ...(zIndex != null ? { zIndex } : {}),
  }

  const overlay = (
    <div
      className={classNames}
      style={overlayStyle}
      role="presentation"
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {children}
    </div>
  )

  if (inline || !portal || typeof document === 'undefined') {
    return overlay
  }

  return createPortal(overlay, document.body)
}

export default Overlay
